// extracted by mini-css-extract-plugin
module.exports =  {"information_withBackground":"InlineMessageInformation-module__information_withBackground___RI8fF","information__icon":"InlineMessageInformation-module__information__icon___wa8xx"};